import { useEffect, useState } from 'react';
import {
    Button, Modal, Checkbox, Skeleton,
} from 'antd';
import { useTranslation } from 'react-i18next';
import produce from 'immer';
import { useFetch } from '../../hooks/useFetch';
import { IOrder } from '../../types/order';

interface IOrderChangeMarksButtonProps {
    order: IOrder;
    onUpdate: () => void;
}

function OrderSelectChangeTypes({ order, onUpdate }: IOrderChangeMarksButtonProps) {
    const { t } = useTranslation();
    const typesFetch = useFetch();
    const saveFetch = useFetch();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selected, setSelected] = useState<string[]>([]);
    const [types, setTypes] = useState<{ label: string; value: string; }[]>([]);

    const getTypes = async () => {
        const response = await typesFetch.request({
            url: '/orders/change-types',
        });
        if (response.success && Array.isArray(response.data)) {
            setTypes(response.data);
        }
    };

    useEffect(() => {
        if (isModalVisible) {
            setSelected(order.selected_change_types);
            getTypes();
        } else {
            setSelected([]);
        }
    }, [isModalVisible]);

    const openModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const handleSave = async () => {
        await saveFetch.request({
            url: `/orders/${order.id}/selected-changes`,
            method: 'patch',
            data: { types: selected },
        });
        setIsModalVisible(false);
        if (typeof onUpdate === 'function') {
            onUpdate();
        }
    };

    const toggleChange = (type: string) => {
        setSelected(produce(selected, (draft) => {
            const index = draft.findIndex((el) => el === type);
            if (index > -1) {
                draft.splice(index, 1);
            } else {
                draft.push(type);
            }
        }));
    };

    return (
        <>
            <Button type="primary" danger onClick={openModal}>
                {t('markChanges')}
            </Button>
            <Modal
                title={t('selectChanges')}
                open={isModalVisible}
                onOk={handleSave}
                onCancel={handleCancel}
                okText={t('confirm')}
                cancelText={t('cancel')}
                confirmLoading={saveFetch.loading}
            >
                <Skeleton loading={typesFetch.loading}>
                    <p>{t('modalDescription')}</p>
                    <div className="order-change-types-conatiner">
                        {types.map((option) => (
                            <Checkbox
                                key={option.value}
                                checked={selected.includes(option.value)}
                                onClick={() => toggleChange(option.value)}
                            >
                                {option.label}
                            </Checkbox>
                        ))}
                    </div>
                </Skeleton>
            </Modal>
        </>
    );
}

export default OrderSelectChangeTypes;
